<template>
    <div class="destinations-content">

        <ais-instant-search :search-client="searchClient" index-name="cities:title:asc">

            <div class="blog-category wrapper">

                <!-- Title -->
                <div class="page-header">
                    <div class="page-title-icon">
                        <svg class="map-icon"><use xlink:href="#map-icon"></use></svg>
                    </div>
                    <h2 class="page-title">
                        Explore destinations
                    </h2>
                </div>

                <!-- Filters -->
                <Filters></Filters>

            </div>

            <!-- Results -->
            <ais-infinite-hits class="blog-grid wrapper">
                        <template v-slot="{ items, refinePrevious, refineNext, isLastPage, sendEvent, }">

                            <div class="blog-grid__inner">
                                <div class="blog-post" v-for="city in items">

                                    <div class="blog-post__image">
                                        <a :href="`/destination/${city.slug}`">
                                            <img :src="city.featured_image">
                                        </a>
                                    </div>

                                    <div class="blog-post__content">

                                        <small>
                                            <a :href="`/destination/${city.slug}`" v-text="city.region.name">
                                            </a>
                                        </small>

                                        <h3>
                                            <a :href="`/destination/${city.slug}`" v-text="city.title">
                                            </a>
                                        </h3>

                                        <div class="tags">
                                            <ul class="tags-list">
                                                <li class="tags-list-item" v-for="tag in city.tags" v-text="tag">
<!--                                                    <a :href="`/destination/${city.slug}/browse?tags=${tag}`" v-text="tag"></a>-->
                                                </li>
                                            </ul>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <!-- Load More -->
                            <div class="wrapper blog-load-more" v-if="!isLastPage">
                                <button  @click="refineNext">
                                    Load More
                                </button>
                            </div>

                        </template>
                </ais-infinite-hits>

        </ais-instant-search>
    </div>
</template>
<script>

import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import Filters from './Filters';

export default {

    components: {
        Filters
    },

    data() {
        const search = (window.config && window.config.search) || {};
        const host = search.meili_host || (window.location.origin + '/meili');
        const key = search.meili_key || 'proxy';

        const { searchClient } = instantMeiliSearch(host, key, { keepZeroFacets: true });

        return {
            searchClient,
        }
    },

    mounted() {
        let timeout
        setTimeout(function () {
            $('.ais-SearchBox-input').focus()
            clearTimeout(timeout)
        }, 200)
    },
}
</script>
